module.exports = __webpack_public_path__ + "static/media/OnlineeducationThinkstockPhotos.e596b0df.jpg";